<template>
  <div class="row">
    <div class="col-lg-4">
      <!-- list of cluster -->
      <card style="height: 75%">
        <ul>
          <li
            v-for="cluster in clusters"
            :key="cluster.addCluster"
            style="margin: 0.5%"
          >
            <card class="card-style">
              <div class="row">
                <div class="col-md-1 d-none d-md-block">
                  <base-button
                    class="remove btn-link"
                    type="success"
                    size="sm"
                    icon
                  >
                    <i
                      class="tim-icons icon-square-pin"
                      @click="
                        setCenter(
                          cluster.cluster_info.lat,
                          cluster.cluster_info.lon
                        )
                      "
                    ></i>
                  </base-button>
                </div>
                <div class="col-md-9">
                  <h4>{{ cluster.cluster_info.clustername }}</h4>
                  <h6>
                    Connnection type: &nbsp;{{ cluster.cluster_info.conntype }}
                  </h6>
                  <h6>
                    Date created: &nbsp;{{
                      cluster.cluster_info.createdAt.split("T")[0]
                    }}
                  </h6>
                  <br />
                </div>
                <div class="col-md-4 btn-view">
                  <base-button
                    class="cluster"
                    type="success"
                    @click="viewDetails(cluster.cluster_info.clusterid)"
                    >View Cluster</base-button
                  >
                </div>
              </div>
            </card>
          </li>
        </ul>
      </card>
    </div>

    <div class="col-lg-8">
      <!-- map -->
      <card type="card-chart" no-footer-line style="height: 75%">
        <loading
          loader="spinner"
          :height="40"
          :width="40"
          color="#00f2c3"
          background-color="#6c757d"
          transition="fade"
          :active="isLoading"
          :is-full-page="false"
        ></loading>
        <template slot="header">
          <h5 class="card-category">Location of Cluster</h5>
          <h3 class="card-title">
            <div class="chart-area">
              <div id="map" class="map">
                <l-map
                  ref="map"
                  id="toto"
                  style="height: 75%"
                  :bounds="bounds"
                  :zoom="zoom"
                  :center="center"
                  :options="{ scrollWheelZoom: false }"
                  class="sidebar-map"
                >
                  <l-tile-layer
                    :url="url"
                    :attribution="attribution"
                  ></l-tile-layer>
                  <l-marker
                    v-for="marker in markers"
                    :lat-lng="marker.location"
                    :key="marker.addMarker"
                    ref="markersRef"
                    @click="viewDetails(marker.clusterID)"
                    :icon="markerIcon()"
                  >
                    <l-tooltip :content="marker.clusterName" />
                  </l-marker>
                </l-map>
              </div>
            </div>
          </h3>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Modal, BasePagination } from "src/components";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LControlSidebar,
  LTooltip,
} from "vue2-leaflet";
import { log } from "util";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { latLngBounds, latLng } from "leaflet";


export default {
  components: {
    Loading,
    BasePagination,
    Modal,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
  },
  data() {
    return {
      markerIcon() {
        return L.icon({
          iconUrl: require("@/assets/img/marker default.png"),
          iconSize: [30, 30], // size of the icon
          iconAnchor: [30, 30], // point of the icon which will corespond to marker's location
          shadowAnchor: [30, 30], // the same for the shadow
          shadowSize: [30, 30],
          popupAnchor: [-3, -76],
        });
      },
      isLoading: false,
      // Attributes for map
      zoom: 5.3,
      center: L.latLng(4.979601, 108.38754),
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [],
      bounds: [[2.921182, 101.636671]],
      // Data for cluster
      clusters: [],
      cluster_created: "",
    };
  },
  methods: {
    setCenter(lat, long) {
      var map = this.$refs.map;
      map.setCenter(L.latLng(lat, long));
    },
    viewDetails(c) {
   
      const clusterid = c;
      this.$router.push({ path: `/cluster/${clusterid}` });
      // this.$router.push("/cluster");
    },
    getClusters() {
      // this.bounds = []
      this.$http
        .get(":8002/api/v1/manage/cluster")
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
          
          } else {
            //login OK!
           
            
            let data = JSON.parse(JSON.stringify(res.message.cluster_list));
            this.clusters = data;
          
            let bounds = []
            for (let i = 0; i < this.clusters.length; i++) {
              let obj = {};
              obj["location"] = L.latLng(
                this.clusters[i].cluster_info.lat,
                this.clusters[i].cluster_info.lon
              );
              obj["clusterName"] = this.clusters[i].cluster_info.clustername;
              obj["clusterConn"] = this.clusters[i].cluster_info.conntype;
              obj["clusterID"] = this.clusters[i].cluster_info.clusterid;
              this.markers.push(obj);
              bounds.push([this.clusters[i].cluster_info.lat,
                this.clusters[i].cluster_info.lon])
            }

            this.bounds = bounds
      
            // this.markers[0].location["lat"] = 3; //Temperoray location
            this.isLoading = false;
          }
        })
        .catch((err) => {
         
        });
    },
  },
  created() {
    this.isLoading = true;
    this.getClusters();
  },
};
</script>

<style scoped>
base-button h4 {
  display: inline;
}
.card-style {
  background-color: rgb(29, 37, 59, 0.8);
  /* margin-bottom: 4%; */
}
.top base-button h5 {
  display: inline;
}
.btn-view {
  position: absolute;
  right: 0;
}
ul {
  height: 535px;
  list-style-type: none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 0%;
}
.cluster {
  padding-right: 10%;
  padding-left: 10%;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>